import React, { useEffect, useState } from "react";
import $ from "jquery";
import { Footer } from "../layouts";
import { NavBar, Spinner } from "../components";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { useParams } from "react-router";

const CompanyDetails = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [spinColor, setSpinColor] = useState("success");

  useEffect(() => {
    let tim2 = setTimeout(() => {
      setIsLoading(false);
    }, 4000);

    return () => {
      clearTimeout(tim2);
    };
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
            }}
          >
            <Spinner grow color={spinColor} size={5} />
          </div>
        </>
      ) : (
        <Main />
      )}

      {/* <Helmet>
        <link
          rel="stylesheet"
          href="../assets/css/bootstrap/icons/bootstrap-icons.css"
        />
        <link
          rel="stylesheet"
          href="../assets/css/hs/mega-menu/mega-menu.min.css"
        />
        <link rel="stylesheet" href="../assets/css/_theme.css" />

        <script
          defer
          asyn
          src="../assets/js/bootstrap/bootstrap.bundle.min.js"
        ></script>
        <script defer asyn src="../assets/js/hs/go-to/goto.min.js"></script>
        <script defer asyn src="../assets/js/prism/prism.js"></script>
        <script
          defer
          asyn
          src="../assets/js/hs/show-animation/show-animation.min.js"
        ></script>
        <script
          defer
          asyn
          src="../assets/js/hs/mega-menu/mega-menu.min.js"
        ></script>
        <script defer asyn src="../assets/js/hs/header/header.min.js"></script>
        <script defer asyn src="../assets/js/fslightbox/index.js"></script>
        <script defer asyn src="../assets/js/theme.min.js"></script>
      </Helmet> */}
    </>
  );
};

export default CompanyDetails;

const Main = () => {
  const [companyDetails, setCompanyDetails] = useState(null);
  const [buttonText, setButtonText] = useState("AFFICHER LE NUMÉRO");
  const { id } = useParams();
  const decodedId = atob(id);
  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await axios.get(
          `https://abn.happynessarl.com/api/v1/company/${decodedId}`
        );
        const data = response.data.data;
        setCompanyDetails(data);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    if (decodedId) {
      fetchCompanyDetails();
    }
    const script = `
    new HSGoTo('.js-go-to');
    new HSHeader('#header').init();
    new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
`;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      $(".homescript").remove();
    };
  }, [decodedId]);

  const handleClick = () => {
    setButtonText(companyDetails.phone);
  };

  return (
    <>
      <NavBar sub />
      <main>
        <div
          className="bg-img-start"
          style={{
            backgroundImage: `url(/assets/img/svg/components/sa.svg)`,
          }}
        >
          <div className={`container text-center content-space-3`}>
            <h2
              className={`display-4 text-uppercase text-primary mt-5`}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span>{companyDetails?.name}</span>
            </h2>
          </div>
        </div>
        <div className="container content-space-2 content-space-lg-0 mb-10">
          <div className="row">
            {companyDetails === null ? (
              <div className="container text-center my-4">
                <Spinner grow={false} color={"success"} size={3} />
              </div>
            ) : (
              <>
                <div className="col-lg-4 mt-lg-n10 mb-7 mb-lg-0">
                  <div className="card border shadow-lg">
                    <div className="card-header border-bottom text-center">
                      <img
                        className="avatar avatar-xxl avatar-4x3"
                        src={companyDetails.logo}
                        alt="Logo"
                      />
                    </div>

                    <div className="card-body">
                      <dl className="row">
                        <dt className="col-sm-4">Email</dt>
                        <dd className="col-sm-8">{companyDetails.email}</dd>
                      </dl>

                      <dl className="row">
                        <dt className="col-sm-4">Pay</dt>
                        <dd className="col-sm-8">{companyDetails.pays}</dd>
                      </dl>

                      <dl className="row">
                        <dt className="col-sm-4">Type</dt>
                        <dd className="col-sm-8">{companyDetails.type}</dd>
                      </dl>

                      <div className="d-flex gap-3 mt-3">
                        <button
                          type="button"
                          className="btn btn-soft-secondary me-1 mb-1 w-100"
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModal"
                        >
                          TÉLÉPHONE
                        </button>
                        <a
                          className="btn btn-soft-secondary me-1 mb-1 w-100"
                          href={companyDetails.site_web}
                          role="button"
                          target="_blank" rel="noreferrer"
                        >
                          SITE WEB
                        </a>
                      </div>

                      <div className="mt-3">
                        <a className="btn btn-outline-primary w-100" href="#" role="button">
                          CONTACTER
                        </a>
                      </div>

                      <hr className="my-4" />

                      <div className="mb-3">
                        <h4>Produits utilisés</h4>
                      </div>

                      <dl className="row">
                        <dt className="col-sm-4 mb-2 mb-sm-0">
                          <img
                            src={companyDetails.logo}
                            alt="logo"
                            width={50}
                          />
                        </dt>
                        <dd className="col-sm-8">
                          <h5 className="mb-0">Portefeuille Amazon</h5>
                          <p className="mb-0">
                            Envoyez des devises ciblées aux bonnes personnes au
                            bon moment.
                          </p>
                        </dd>
                      </dl>

                      <dl className="row">
                        <dt className="col-sm-4 mb-2 mb-sm-0">
                          <img
                            src={companyDetails.logo}
                            alt="logo"
                            width={50}
                          />
                        </dt>
                        <dd className="col-sm-8">
                          <h5 className="mb-0">Portefeuille Amazon</h5>
                          <p className="mb-0">
                            Envoyez des devises ciblées aux bonnes personnes au
                            bon moment.
                          </p>
                        </dd>
                      </dl>
                    </div>
                  </div>
                  <div className="border p-3 rounded mt-3 text-center">
                    <a href="#" className="btn btn-soft-secondary me-1 mb-1 w-100">
                      AJOUTER À LA SHORTLIST
                    </a>
                  </div>
                </div>
                <div className="col-lg-8 content-space-t-lg-2">
                  <div className="ps-lg-4">
                    <h2 className="h3">
                      It's difficult to imagine life pre-Internet, before the
                      web so closely threaded together individuals around the
                      world.
                    </h2>
                    <p>
                      It takes work to stand out from the pack—work that Amazon
                      is proud to make much easier. Founded in 2003, the company
                      provides people with the tools and templates to build,
                      host, and promote their online brand. Even Amazon is built
                      on Amazon.
                    </p>

                    <p>
                      "The key thing we try to do every day is give people a
                      place on the Internet to call home, to say, 'This is a
                      place I manage, and this is how I want to present myself
                      online to my customers,' or to anyone else they want to
                      touch,"" explained Vice President of Customer Operations
                      Raphael Front.
                    </p>

                    <p>
                      Naturally, Amazon wants its customers to feel at ease in
                      their digital home and works hard behind the scenes to
                      create a customer experience that is easy and intuitive,
                      turning even the least Internet-savvy among us into
                      designers of beautiful spaces. To cultivate a support
                      atmosphere that's inviting, Amazon's customer service team
                      has implemented a full suite of integrated support
                      channels through Front Support, Guide, Chat, and Talk.
                    </p>

                    <p>
                      Before switching to Front in 2015, Amazon used a few
                      different platforms for support, but felt they needed a
                      single omnichannel solution to provide a more fluid
                      customer experience and to keep pace with the company's
                      growth. Front' Customer Operations organization, comprised
                      of 340 people in leadership, operations, product
                      solutions, content and community, and quality assurance,
                      also needed a more efficient way to manage email and help
                      articles.
                    </p>

                    <p>
                      "I don't think there was even anyone else that we
                      considered," he said. "Front was like a no
                      brainer—instead, we spent our time thinking through our
                      support configuration."
                    </p>

                    <p>
                      Amazon's overall strategy focuses on three areas, Front
                      explained, noting that what the team offers is, in fact,
                      another Amazon product. "It's not just that we have a help
                      center or live chat," he said, "but that we're offering
                      coaching and mentorship and helping our customers to
                      become brand advocates. We're here to help our customers
                      succeed online, and that's something we hear back from our
                      customers. They just love our support channels."
                    </p>

                    <p>
                      That effort shows, as the team has created 900 help center
                      articles and claims a 95 percent success rate through its
                      investment in self-service, meaning that help center
                      visitors are served without needing to switch to an
                      assisted channel. The number of tickets not created, as a
                      result, is significant, especially considering that
                      Amazon's help center has bypassed 15.5 million visits and
                      now averages two million visits each month. Front
                      quantified a 27 percent increase in knowledge usage and
                      noted that headcount on the Customer Operations team has
                      remained relatively stable since the end of 2015 through
                      mid-2018.
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title fs-3" id="exampleModalLabel">
                  Téléphones supplémentaires
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <h4>Autre</h4>
                <div className="d-flex align-items-center gap-10">
                  <p className="mt-3">Téléphone</p>
                  <button
                    type="button"
                    className="btn btn-primary w-100 fs-6"
                    onClick={handleClick}
                  >
                    {buttonText}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer sub />
    </>
  );
};
